import { combineReducers } from 'redux';

import commonReducer from 'modules/common/reducer';
import generalReducer from 'modules/general/reducer';
import masterServicesReducer from 'modules/masterServices/reducer';
import servicesReducer from 'modules/services/reducer';

export default combineReducers({
  common: commonReducer,
  general: generalReducer,
  masterServices: masterServicesReducer,
  services: servicesReducer,
});
